const PromiseQueue: Promise<any>[] = []
let depth = 0

/**
 * 同步重试执行机制
 * 1. 当前层级报错不中断，会把错误推入队列
 * 2. 父层级执行结束会检查错误队列是否有错误，如果有错误，试图重新执行一次，如果还报错则不做任何处理，等父级继续处理
 * 3. 根层级如果每次执行结束检查队列中一直有错误，重复 2 次，会直接中断抛错
 * @param func
 * @param onError
 */
export function suspend<T>(func: () => T, onError?: (error: Error) => void): T {
  depth++
  let result: any
  try {
    result = func()
  } catch (error) {
    if (depth > 0 && error instanceof Promise) {
      PromiseQueue.push(error)
      return result
    }
    if (onError) onError(error as Error)
    else throw error
  } finally {
    depth--
    if (depth === 0 && PromiseQueue.length > 0) {
      const queue = PromiseQueue.slice()
      PromiseQueue.length = 0
      // eslint-disable-next-line no-unsafe-finally
      throw Promise.all(queue)
    }
  }

  return result
}
